import React from 'react'
import { useQuery } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { IGoodsProductTypeOption } from './options.type'

export const useGoodsProductTypes = () => {
  const { data, isLoading, refetch } = useQuery<IGoodsProductTypeOption[]>(
    ['/options/productTypes'],
    {
      select: data => {
        return pathOr([], ['data'], data)
      },
    }
  )

  const byId = React.useMemo(() => {
    return indexBy(prop('id'), data || [])
  }, [data])

  return { data, isLoading, refetch, byId }
}
